import { useMutation } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IAllLeadsResponse } from "../models/Lead";
import apiConfig from "../utils/apiConfig";

export default function useLeadByVehicleId(componentName = "useLeadByVehicleId") {
  const { get } = useApiHelper(apiConfig(componentName));

  const lead = useMutation({
    mutationFn: (vehicleId: string) =>
      get<IAllLeadsResponse>(`/lead/partialbyvehicle?vehicleId=${vehicleId}`),
  });

  return {
    lead,
  };
}
